import { Card, CardContent } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

export default function AntiDiscrimination() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <SEOHead 
        title="Non-Discrimination Policy | Woods Spine & Wellness"
        description="Our commitment to inclusive care and non-discrimination policy at Woods Spine & Wellness."
        canonical="https://woodsspine.com/anti-discrimination"
      />
      <Navbar />
      <main className="flex-grow">
        <section className="bg-primary py-16 text-primary-foreground text-center">
          <div className="container mx-auto px-4">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Non-Discrimination Policy</h1>
            <p className="text-xl opacity-90">Our commitment to inclusive care.</p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-4 max-w-4xl">
            <Card className="shadow-lg border-0">
              <CardContent className="p-8 md:p-12 prose prose-slate max-w-none">
                <p className="text-lg text-muted-foreground mb-8">
                  Woods Spine & Wellness complies with applicable Federal civil rights laws and does not discriminate on the basis of race, color, national origin, age, disability, or sex. Woods Spine & Wellness does not exclude people or treat them differently because of race, color, national origin, age, disability, or sex.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Woods Spine & Wellness:</h3>
                <ul className="list-disc pl-6 mb-6 space-y-4">
                  <li>
                    Provides free aids and services to people with disabilities to communicate effectively with us, such as:
                    <ul className="list-circle pl-6 mt-2 space-y-1">
                      <li>Qualified sign language interpreters</li>
                      <li>Written information in other formats (large print, audio, accessible electronic formats, other formats)</li>
                    </ul>
                  </li>
                  <li>
                    Provides free language services to people whose primary language is not English, such as:
                    <ul className="list-circle pl-6 mt-2 space-y-1">
                      <li>Qualified interpreters</li>
                      <li>Information written in other languages</li>
                    </ul>
                  </li>
                </ul>

                <p className="mb-6">
                  If you need these services, contact our office.
                </p>

                <h3 className="text-2xl font-bold text-primary mb-4">Filing a Grievance</h3>
                <p className="mb-4">
                  If you believe that Woods Spine & Wellness has failed to provide these services or discriminated in another way on the basis of race, color, national origin, age, disability, or sex, you can file a grievance with our office.
                </p>

                <p className="mb-4">
                  You can also file a civil rights complaint with the U.S. Department of Health and Human Services, Office for Civil Rights, electronically through the Office for Civil Rights Complaint Portal, available at <a href="https://ocrportal.hhs.gov/ocr/portal/lobby.jsf" target="_blank" rel="noopener noreferrer" className="text-accent underline hover:text-accent/80">https://ocrportal.hhs.gov/ocr/portal/lobby.jsf</a>, or by mail or phone at:
                </p>

                <div className="bg-muted p-6 rounded-lg mt-8">
                  <p className="font-bold mb-2">U.S. Department of Health and Human Services</p>
                  <p className="mb-1">200 Independence Avenue, SW</p>
                  <p className="mb-1">Room 509F, HHH Building</p>
                  <p className="mb-1">Washington, D.C. 20201</p>
                  <p className="mb-1">1-800-368-1019, 800-537-7697 (TDD)</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
